import React from "react";
import { Box } from "@mui/material";

export default function FableTokenAmount({ amount, kind = "amount", iconSrc = "/coin.png" }: { amount: React.ReactNode; kind?: "amount" | "price"; iconSrc?: string }) {
  // Older cost buttons include their own multiplier. Prices render it once here.
  const value = kind === "price" && typeof amount === "string"
    ? amount.replace(/^\s*[×x]\s*|\s*[×x]\s*$/g, "") : amount;
  return <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, maxWidth: "100%", verticalAlign: "middle", whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" }}>
    <Box component="span" sx={{ minWidth: 0, whiteSpace: "normal" }}>{typeof value === "string" ? value.split("–").map((part, index) => <React.Fragment key={index}>{index > 0 && <>–<wbr /></>}{part}</React.Fragment>) : value}</Box>
    {kind === "price" && <Box component="span" aria-hidden="true" sx={{ color: "inherit", opacity: 0.7, flexShrink: 0 }}>×</Box>}
    <Box component="img" className="token-cost-icon" src={iconSrc} alt="Fable tokens" sx={{ width: "1.1em", height: "1.1em", flexShrink: 0, opacity: 1, filter: "none" }} />
  </Box>;
}
